import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addProgramTermsConsent } from "services";

import { ADD_PROGRAM_TERMS_CONSENT, GET_FARMS } from "consts";

type programConsent = {
  programId: string;
  accepted?: boolean;
};

export const useAddProgramTermsConsents = ({ programConsents = [] }: { programConsents: programConsent[] }) => {
  const queryClient = useQueryClient();

  return useMutation(
    {
      mutationKey: [ADD_PROGRAM_TERMS_CONSENT],
      mutationFn: async () => Promise.all(programConsents.map(({ programId, accepted }) => addProgramTermsConsent({ programId, accepted }))),
      onSuccess: async () => {
        queryClient.invalidateQueries({ queryKey: [GET_FARMS] });
      },
    },
    queryClient
  );
};
